var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 450,
    viewBox: "0 0 567 567",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400.931 0C396.106 93.6959 473.304 170.894 567 166.069C497.428 228.948 497.428 338.052 567 400.931C473.304 396.106 396.106 473.304 400.931 567C338.052 497.428 228.948 497.428 166.069 567C170.894 473.304 93.6959 396.106 0 400.931C69.5715 338.052 69.5715 228.948 0 166.069C93.6959 170.894 170.894 93.6959 166.069 0C228.792 69.5715 338.052 69.5715 400.931 0Z",
    fill: "#D8FF3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroCenter);
export default __webpack_public_path__ + "static/media/intro_center.3002d63c2c18338bfd9a6790183e81a6.svg";
export { ForwardRef as ReactComponent };